import { Component, Input, Output, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgcFloatButtonModule } from 'ngc-float-button';
import { QuestionBase, QuestionUITypes, QuestionElement } from '../question-base';
import { EventEmitter } from 'events';
import { CustomerEditService } from '../services/customer-edit/customer-edit.service';
import { ModalQuestion } from '../question-modal';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../services/modal/modal.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiService } from '../services/api/api.service';
import { FormValuesService } from '../services/form-values/form-values.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-dynamic-form-question',
  templateUrl: './dynamic-form-question.component.html',
  styleUrls: ['./dynamic-form-question.component.css', '../test/test.component.css']
})
export class DynamicFormQuestionComponent implements OnChanges {

  public questionTypesEnum = QuestionUITypes;
  public datepickerBindingVar;
  public subQuestions: Array<QuestionElement> = [];
  public open:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private insuranceContents = [];
  
  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;
  @Output() updateKidsInput: EventEmitter = new EventEmitter();
  
  constructor(
    private customerEditService: CustomerEditService,
    private modalService: ModalService,
    public  apiService: ApiService,
    public  formValueService: FormValuesService
  ){}
  
  ngOnChanges(ch) {
    if (this.question instanceof ModalQuestion ){
      this.subQuestions = (this.question as ModalQuestion).getQuestionsElementsInOrder();
      this.modalService.setQuestions(this.question.modalId, this.subQuestions);
    } else if(this.question.key.substring(0,12) === 'geburtsdatum' ){
      let tmp = [];

      if( this.question.getValue() ){
        tmp = this.question.getValue().split( '.' );
      } else if ( this.question.getStandardValue() ){
        
        if( this.question.getStandardValue().day && this.question.getStandardValue().month && this.question.getStandardValue().year ){
          let date = this.question.getStandardValue();
          tmp = [ date.day, date.month, date.year ];
        } else {
          tmp = this.question.getStandardValue().split( '.' );  
        }                
      }

      if( tmp.length !== 3 ){
        this.datepickerBindingVar = { day: 1, month: 1, year: 1990, };
      }else{
        this.datepickerBindingVar = { day: ~~tmp[0], month: ~~tmp[1], year: ~~tmp[2], };
      }
    } else if ( 
      this.question.key == "versorgungszielEm" ||   
      this.question.key == "benEmBu" ||
      this.question.key == "benAlter"
    ){
      this.apiService.nettoObs().subscribe(data => {
        data.then(result => {
         // console.log(this.question.getValue()); > 0
          this.question.setLiveValue(result.result[0].Person1.Ergebnis.Nettoentgelt);
        })
      });
    }
  }

  public isValid() { 
    if(this.form.controls[this.question.key]){
      return this.form.controls[this.question.key].valid;
    }else{
      return true;
    }
  }
  
  public objectKeys( obj ){
    return Object.keys(obj);
  }
  
  private updateInputfields(todo){
    this.customerEditService.updateForm(todo);
  } 
  
  public birthCheck(str){
    return str.substring(0,12);
  }
  
  public openThisModal(){
    this.open.next(false)
    this.modalService.openModal(this.question.executeId, this.form)
    .then( (result) => {
      return this.apiService.getModalContentPlaceholder();
    })
    .then( ( apiInsuranceContents ) => {
      this.insuranceContents = apiInsuranceContents;
    });
  }
  
  public calcNetto(todo){    
    this.apiService.emitNettoValues()
    .then(() => {
      this.apiService.getNettoValues()
      .then( (result: any) => {
        this.question.setLiveValue(result.result[0].Person1.Ergebnis.Nettoentgelt);
      })
    }, error => {
      console.error(error);
    });
  }
  
  private removeContent(i){
    this.insuranceContents.splice(i, 1);    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/dynamic-form-question/dynamic-form-question.component.ts